import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import API from "../Context/api";
import AddDeliveryNoteForm from "../DeliveryNotes/AddDeliveryNoteForm";
import EditDeliveryNoteForm from "../DeliveryNotes/EditDeliveryNoteForm";
import { useAuth } from "../Context/AuthContext";

function DeliveryNotes() {
  const [deliveryNotes, setDeliveryNotes] = useState([]);
  const [deliveryNoteToDelete, setDeliveryNoteToDelete] = useState(null);
  const [deliveryNoteToEdit, setDeliveryNoteToEdit] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [searchQuery, setSearchQuery] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [modalOpenEdit, setModalOpenEdit] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false); // State for deleting status

  const navigate = useNavigate();

  const { user } = useAuth();
  const isAdmin = user?.role === "Admin";

  // Fetch delivery notes
  const fetchDeliveryNotes = async () => {
    try {
      const response = await API.get("/deliverynotes");
      console.log(response);
      setDeliveryNotes(response.data);
      setLoading(false);
    } catch (error) {
      setError("Failed to fetch delivery notes");
      setLoading(false);
      console.error("Error fetching delivery notes:", error);
    }
  };

  useEffect(() => {
    fetchDeliveryNotes();
  }, []);

  // Open delete confirmation modal
  const handleDeleteClick = (id) => {
    setDeliveryNoteToDelete(id);
    setModalOpen(true);
  };
  if (loading) {
    return (
      <div className="flex items-center justify-center h-full">
        <div className="text-gray-500 text-lg animate-pulse">Loading...</div>
      </div>
    );
  }

  if (error)
    return <div className="text-center text-red-500 py-10">{error}</div>;

  // Function to close delete modal
  const closeModal = () => {
    setModalOpen(false);
    setDeliveryNoteToDelete(null);
    setIsDeleting(false); // Reset deleting state
  };

  // Delete delivery note
  const handleDeleteDeliveryNote = async () => {
    if (deliveryNoteToDelete) {
      setIsDeleting(true); // Set deleting state to true

      try {
        await API.delete(`/deliverynotes/${deliveryNoteToDelete}`);
        // setDeliveryNotes(
        //   deliveryNotes.filter((note) => note.id !== deliveryNoteToDelete)
        // );
        fetchDeliveryNotes();
      } catch (error) {
        console.error("Error deleting delivery note:", error);
        alert("Failed to delete delivery note.");
      } finally {
        closeModal();
      }
    }
  };

  // Edit delivery note
  const handleEditDeliveryNote = (id) => {
    setDeliveryNoteToEdit(id);
    setModalOpenEdit(true);
  };

  // View delivery note
  const handleViewDeliveryNote = (id) => {
    navigate(`/deliverynote/${id}`);
  };

  // Handle search input change
  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
  };

  // Filter delivery notes based on search query
  const filteredDeliveryNotes = deliveryNotes.filter((note) =>
    (note.invoiceDetails?.client || "")
      .toLowerCase()
      .includes(searchQuery.toLowerCase())
  );

  const handleAddDeliveryNote = () => {
    setIsModalOpen(true);
  };

  // Callback to refresh data after adding or editing
  const handleDeliveryNoteUpdated = () => {
    fetchDeliveryNotes();
    setIsModalOpen(false);
    setModalOpenEdit(false);
  };

  return (
    // <div className="p-4 bg-gray-50 min-h-full flex flex-col">
    //   {/* Sticky Search Bar */}
    //   <div className="bg-white rounded-lg shadow-sm p-4 sticky top-0 z-10">
    //     <div className="flex flex-col sm:flex-row justify-between items-center gap-4">
    //       <input
    //         type="text"
    //         placeholder="Search by customer..."
    //         value={searchQuery}
    //         onChange={handleSearchChange}
    //         className="w-full sm:w-72 p-3 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200"
    //       />

    //       <button
    //         onClick={handleAddDeliveryNote}
    //         className="w-full sm:w-auto bg-blue-600 text-white px-6 py-2 rounded-lg shadow-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-opacity-50 transition-all duration-200"
    //       >
    //         Add Delivery Note
    //       </button>
    //     </div>
    //   </div>
    //   {/* Top Bar */}
    //   {/* <div className="flex flex-col sm:flex-row justify-between items-center mb-6 gap-4">
    //     <input
    //       type="text"
    //       placeholder="Search by customer..."
    //       value={searchQuery}
    //       onChange={handleSearchChange}
    //       className="w-full sm:w-72 p-3 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200"
    //     />
    //     <button
    //       onClick={handleAddDeliveryNote}
    //       className="w-full sm:w-auto bg-blue-600 text-white px-6 py-2 rounded-lg shadow-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-opacity-50 transition-all duration-200"
    //     >
    //       Add Delivery Note
    //     </button>
    //   </div> */}

    //   {/* Table for Medium and Larger Screens */}
    //   <div className="hidden sm:block bg-white rounded-lg shadow-sm">
    //     <table className="w-full text-left table-fixed">
    //       <thead className="bg-gray-100 sticky">
    //         <tr>
    //           <th className="w-[12%] px-4 py-3 text-sm font-semibold text-gray-600 uppercase tracking-wider">
    //             Delivery Note No
    //           </th>
    //           <th className="w-[12%] px-4 py-3 text-sm font-semibold text-gray-600 uppercase tracking-wider">
    //             Customer
    //           </th>
    //           <th className="w-[12%] px-4 py-3 text-sm font-semibold text-gray-600 uppercase tracking-wider">
    //             Date
    //           </th>
    //           <th className="w-[12%] px-4 py-3 text-sm font-semibold text-gray-600 uppercase tracking-wider">
    //             Total (UGX)
    //           </th>
    //           <th className="w-[12%] px-4 py-3 text-sm font-semibold text-gray-600 uppercase tracking-wider">
    //             Actions
    //           </th>
    //         </tr>
    //       </thead>
    //       <tbody className="divide-y divide-gray-100">
    //         {filteredDeliveryNotes.map((note) => (
    //           <tr
    //             key={note.id}
    //             className="hover:bg-gray-50 transition-colors duration-150"
    //           >
    //             <td className="px-4 py-3 text-gray-700 text-sm whitespace-normal break-words align-top">
    //               {note.invoiceDetails.DeliveryNoteNo}
    //             </td>
    //             <td className="px-4 py-3 text-gray-700 text-sm whitespace-normal break-words align-top">
    //               {note.invoiceDetails.client}
    //             </td>
    //             <td className="px-4 py-3 text-gray-700 text-sm whitespace-normal break-words align-top">
    //               {new Date(note.invoiceDetails.date).toLocaleDateString()}
    //             </td>
    //             <td className="px-4 py-3 text-gray-700 text-sm whitespace-normal break-words align-top">
    //               {note.invoiceDetails.totalAmount.toLocaleString()}
    //             </td>
    //             <td className="px-4 py-3 flex gap-2 flex-col justify-start items-start flex-wrap">
    //               <button
    //                 onClick={() => handleViewDeliveryNote(note.deliveryNoteID)}
    //                 className="bg-blue-500 text-white w-20 px-3 py-1 rounded-md hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-400 focus:ring-opacity-50 transition-all duration-200"
    //               >
    //                 View
    //               </button>
    //               <button
    //                 onClick={() => handleEditDeliveryNote(note.deliveryNoteID)}
    //                 className="bg-blue-500 text-white w-20 px-3 py-1 rounded-md hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-400 focus:ring-opacity-50 transition-all duration-200"
    //               >
    //                 Edit
    //               </button>

    //               {isAdmin && (
    //                 <>
    //                   <button
    //                     onClick={() => handleDeleteClick(note.deliveryNoteID)}
    //                     className="bg-red-500 text-white w-20 px-3 py-1 rounded-md hover:bg-red-600 focus:outline-none focus:ring-2 focus:ring-red-400 focus:ring-opacity-50 transition-all duration-200"
    //                   >
    //                     Delete
    //                   </button>
    //                 </>
    //               )}
    //             </td>
    //           </tr>
    //         ))}
    //       </tbody>
    //     </table>
    //   </div>

    //   {/* Cards for Small Screens */}
    //   <div className="md:hidden space-y-4">
    //     {filteredDeliveryNotes.map((note) => (
    //       <div key={note.id} className="bg-white p-4 rounded-lg shadow-md">
    //         <h3 className="text-lg font-semibold text-gray-900 truncate">
    //           {note.invoiceDetails.DeliveryNoteNo}
    //         </h3>
    //         <p className="text-sm text-gray-600 mt-1">
    //           {note.invoiceDetails.client}
    //         </p>
    //         <p className="text-sm text-gray-500">
    //           Date: {new Date(note.invoiceDetails.date).toLocaleDateString()}
    //         </p>
    //         <p className="text-sm text-gray-500">
    //           Total: UGX {note.invoiceDetails.totalAmount.toLocaleString()}
    //         </p>
    //         <div className="mt-3 flex flex-wrap gap-2">
    //           <button
    //             onClick={() => handleViewDeliveryNote(note.deliveryNoteID)}
    //             className="bg-blue-500 text-white px-3 py-1 rounded-md hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-400 focus:ring-opacity-50 transition-all duration-200"
    //           >
    //             View
    //           </button>
    //           <button
    //             onClick={() => handleEditDeliveryNote(note.deliveryNoteID)}
    //             className="bg-blue-500 text-white w-20 px-3 py-1 rounded-md hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-400 focus:ring-opacity-50 transition-all duration-200"
    //           >
    //             Edit
    //           </button>

    //           {isAdmin && (
    //             <>
    //               <button
    //                 onClick={() => handleDeleteClick(note.deliveryNoteID)}
    //                 className="bg-red-500 text-white px-3 py-1 rounded-md hover:bg-red-600 focus:outline-none focus:ring-2 focus:ring-red-400 focus:ring-opacity-50 transition-all duration-200"
    //               >
    //                 Delete
    //               </button>
    //             </>
    //           )}
    //         </div>
    //       </div>
    //     ))}
    //   </div>

    //   {/* Delete Confirmation Modal */}
    //   {modalOpen && (
    //     <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-60 z-50 px-4">
    //       <div className="bg-white p-6 rounded-lg shadow-xl w-full max-w-md">
    //         <h2 className="text-xl font-bold text-gray-900">
    //           Confirm Deletion
    //         </h2>
    //         <p className="text-gray-600 mt-2">
    //           Are you sure you want to delete this delivery note?
    //         </p>
    //         <div className="mt-6 flex justify-end gap-3">
    //           <button
    //             onClick={closeModal}
    //             className="bg-gray-500 text-white px-4 py-2 rounded-md hover:bg-gray-600 focus:outline-none focus:ring-2 focus:ring-gray-400 focus:ring-opacity-50 transition-all duration-200"
    //           >
    //             Cancel
    //           </button>
    //           <button
    //             onClick={handleDeleteDeliveryNote}
    //             disabled={isDeleting}
    //             className="bg-red-500 text-white px-4 py-2 rounded-md hover:bg-red-600 focus:outline-none focus:ring-2 focus:ring-red-400 focus:ring-opacity-50 transition-all duration-200"
    //           >
    //             {isDeleting ? "Deleting..." : "Delete"}
    //           </button>
    //         </div>
    //       </div>
    //     </div>
    //   )}

    //   {/* Add Delivery Note Modal */}
    //   {isModalOpen && (
    //     // <div className="fixed inset-0 flex items-center justify-center bg-gray-900 bg-opacity-60 z-50">
    //     //   <div className="w-full max-w-4xl h-[90vh] bg-white p-6 rounded-lg shadow-xl overflow-y-auto">
    //     //     <AddDeliveryNoteForm
    //     //       setIsModalOpen={setIsModalOpen}
    //     //       onDeliveryNoteUpdated={handleDeliveryNoteUpdated}
    //     //     />
    //     //   </div>
    //     // </div>
    //     <AddDeliveryNoteForm
    //       setIsModalOpen={setIsModalOpen}
    //       onDeliveryNoteUpdated={handleDeliveryNoteUpdated}
    //     />
    //   )}

    //   {/* Edit Delivery Note Modal */}
    //   {modalOpenEdit && (
    //     // <div className="fixed inset-0 flex items-center justify-center bg-gray-900 bg-opacity-60 z-50">
    //     //   <div className="w-full max-w-4xl h-[90vh] bg-white p-6 rounded-lg shadow-xl overflow-y-auto">
    //     //     <EditDeliveryNoteForm
    //     //       id={deliveryNoteToEdit}
    //     //       setIsModalOpen={setModalOpenEdit}
    //     //       onDeliveryNoteUpdated={handleDeliveryNoteUpdated}
    //     //     />
    //     //   </div>
    //     // </div>
    //     <EditDeliveryNoteForm
    //       id={deliveryNoteToEdit}
    //       setIsModalOpen={setModalOpenEdit}
    //       onDeliveryNoteUpdated={handleDeliveryNoteUpdated}
    //     />
    //   )}
    // </div>

    <div className="h-full flex flex-col">
      {/* Static Header */}
      <h3 className="text-xl font-semibold mb-2 text-gray-900">
        Delivery Notes
      </h3>

      <div className="py-2 mb-4 flex items-center justify-between gap-4 flex-wrap">
        <input
          type="text"
          placeholder="Search by customer..."
          value={searchQuery}
          onChange={handleSearchChange}
          className="p-2 border rounded w-full md:w-64 focus:ring-2 focus:ring-indigo-500 focus:outline-none"
        />

        <button
          onClick={handleAddDeliveryNote}
          className="px-4 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600 text-sm font-medium transition-all duration-200 shadow-sm w-full sm:w-auto"
        >
          Add Delivery Note
        </button>
      </div>

      {/* Scrollable Content */}
      <div className="flex-1 overflow-y-auto space-y-3">
        <div className="hidden sm:block bg-white rounded-lg shadow-sm">
          <table className="w-full text-left table-fixed">
            <thead className="bg-gray-100 sticky top-0 z-10">
              <tr>
                <th className="w-[12%] px-4 py-3 text-sm font-semibold text-gray-600 uppercase tracking-wider">
                  Delivery Note No
                </th>
                <th className="w-[12%] px-4 py-3 text-sm font-semibold text-gray-600 uppercase tracking-wider">
                  Customer
                </th>
                <th className="w-[12%] px-4 py-3 text-sm font-semibold text-gray-600 uppercase tracking-wider">
                  Date
                </th>
                <th className="w-[12%] px-4 py-3 text-sm font-semibold text-gray-600 uppercase tracking-wider">
                  Total (UGX)
                </th>
                <th className="w-[15%] px-4 py-3 text-sm font-semibold text-gray-600 uppercase tracking-wider">
                  Actions
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-300">
              {filteredDeliveryNotes.map((note, index) => (
                <tr
                  key={note.id}
                  className={`text-sm ${
                    index % 2 === 0 ? "bg-white" : "bg-gray-50"
                  } hover:bg-gray-100 transition-colors duration-150`}
                >
                  <td className="px-4 py-3 text-gray-700 text-sm whitespace-normal break-words align-top">
                    <span
                      onClick={() =>
                        handleViewDeliveryNote(note.deliveryNoteID)
                      }
                      className="hover:underline cursor-pointer"
                    >
                      {note.invoiceDetails.DeliveryNoteNo}
                    </span>
                  </td>
                  <td className="px-4 py-3 text-gray-700 text-sm whitespace-normal break-words align-top">
                    {note.invoiceDetails.client}
                  </td>
                  <td className="px-4 py-3 text-gray-700 text-sm whitespace-normal break-words align-top">
                    {new Date(note.invoiceDetails.date).toLocaleDateString()}
                  </td>
                  <td className="px-4 py-3 text-gray-700 text-sm whitespace-normal break-words align-top">
                    {note.invoiceDetails.totalAmount.toLocaleString()}
                  </td>

                  <td className="px-4 py-3 flex gap-2 justify-start items-start flex-wrap">
                    {/* <button
                      onClick={() =>
                        handleViewDeliveryNote(note.deliveryNoteID)
                      }
                      className="bg-blue-500 text-white w-20 px-3 py-1 rounded-md hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-400 focus:ring-opacity-50 transition-all duration-200"
                    >
                      View
                    </button> */}
                    <button
                      onClick={() =>
                        handleEditDeliveryNote(note.deliveryNoteID)
                      }
                      className="bg-blue-500 text-white w-20 px-3 py-1 rounded-md hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-400 focus:ring-opacity-50 transition-all duration-200"
                    >
                      Edit
                    </button>

                    {isAdmin && (
                      <button
                        onClick={() => handleDeleteClick(note.deliveryNoteID)}
                        className="bg-red-500 text-white w-20 px-3 py-1 rounded-md hover:bg-red-600 focus:outline-none focus:ring-2 focus:ring-red-400 focus:ring-opacity-50 transition-all duration-200"
                      >
                        Delete
                      </button>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {/* Cards for Small Screens */}
        <div className="md:hidden space-y-4">
          {filteredDeliveryNotes.map((note) => (
            <div key={note.id} className="bg-white p-4 rounded-lg shadow-md">
              <h3 className="text-lg font-semibold text-gray-900 truncate">
                <span
                  onClick={() => handleViewDeliveryNote(note.deliveryNoteID)}
                  className="hover:underline cursor-pointer"
                >
                  {note.invoiceDetails.DeliveryNoteNo}
                </span>
              </h3>
              <p className="text-sm text-gray-600 mt-1">
                {note.invoiceDetails.client}
              </p>
              <p className="text-sm text-gray-500">
                Date: {new Date(note.invoiceDetails.date).toLocaleDateString()}
              </p>
              <p className="text-sm text-gray-500">
                Total: UGX {note.invoiceDetails.totalAmount.toLocaleString()}
              </p>
              <div className="mt-3 flex flex-wrap gap-2">
                {/* <button
                  onClick={() => handleViewDeliveryNote(note.deliveryNoteID)}
                  className="bg-blue-500 text-white px-3 py-1 rounded-md hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-400 focus:ring-opacity-50 transition-all duration-200"
                >
                  View
                </button> */}
                <button
                  onClick={() => handleEditDeliveryNote(note.deliveryNoteID)}
                  className="bg-blue-500 text-white w-20 px-3 py-1 rounded-md hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-400 focus:ring-opacity-50 transition-all duration-200"
                >
                  Edit
                </button>

                {isAdmin && (
                  <>
                    <button
                      onClick={() => handleDeleteClick(note.deliveryNoteID)}
                      className="bg-red-500 text-white px-3 py-1 rounded-md hover:bg-red-600 focus:outline-none focus:ring-2 focus:ring-red-400 focus:ring-opacity-50 transition-all duration-200"
                    >
                      Delete
                    </button>
                  </>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Delete Confirmation Modal */}
      {modalOpen && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-60 z-50 px-4">
          <div className="bg-white p-6 rounded-lg shadow-xl w-full max-w-md">
            <h2 className="text-xl font-bold text-gray-900">
              Confirm Deletion
            </h2>
            <p className="text-gray-600 mt-2">
              Are you sure you want to delete this delivery note?
            </p>
            <div className="mt-6 flex justify-end gap-3">
              <button
                onClick={closeModal}
                className="bg-gray-500 text-white px-4 py-2 rounded-md hover:bg-gray-600 focus:outline-none focus:ring-2 focus:ring-gray-400 focus:ring-opacity-50 transition-all duration-200"
              >
                Cancel
              </button>
              <button
                onClick={handleDeleteDeliveryNote}
                disabled={isDeleting}
                className="bg-red-500 text-white px-4 py-2 rounded-md hover:bg-red-600 focus:outline-none focus:ring-2 focus:ring-red-400 focus:ring-opacity-50 transition-all duration-200"
              >
                {isDeleting ? "Deleting..." : "Delete"}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Add Delivery Note Modal */}
      {isModalOpen && (
        <AddDeliveryNoteForm
          setIsModalOpen={setIsModalOpen}
          onDeliveryNoteUpdated={handleDeliveryNoteUpdated}
        />
      )}

      {/* Edit Delivery Note Modal */}
      {modalOpenEdit && (
        <EditDeliveryNoteForm
          id={deliveryNoteToEdit}
          setIsModalOpen={setModalOpenEdit}
          onDeliveryNoteUpdated={handleDeliveryNoteUpdated}
        />
      )}
    </div>
  );
}

export default DeliveryNotes;
